import { FC } from "react";

import { LogInMolecule } from "../../molecules";
import logoUppiness from "../../../assets/icons/logoUppiness.svg";
import { CornerCirclesBackground } from "../../atoms";

const LogIn: FC<{}> = () => {

    return (
        <CornerCirclesBackground >
            <div className="center_horizontally_and_vertically" style={{width: "100vw", height: "100vh", overflowY: "scroll"}}>
                <div className="log_in">
                    <img className="log_in_logo" src={logoUppiness} alt="Uppiness Logo" />
                    <div className="elipse" />
                    <div className="log_in_molecule_wrapper">
                        <LogInMolecule />
                    </div>
                </div>
            </div>
        </CornerCirclesBackground>
    );
};

export default LogIn;